export default __webpack_public_path__ + "static/media/chakan.619ec285.png";